module.exports = __webpack_public_path__ + "static/media/ABT_01.5cb7500a.png";